import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';
import Close from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import { useTranslation } from '../../hooks/useTranslation';
import Bill from '../../static/sample-bill.svg';
import TextLink from '../text-link';
import Box from '@material-ui/core/Box';

const useTooltipStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: {
      backgroundColor: '#fff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 260,
      height: '190px',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }),
);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    closeIcon: {
      position: 'absolute',
      top: '4px',
      right: '-10px',
    },
  }),
);

type Props = {
  tabIndex?: number;
  showCloseIcon?: boolean;
  children?: React.ReactNode;
};

export default ({ tabIndex, showCloseIcon, children }: Props) => {
  const { t } = useTranslation();
  const tooltipClasses = useTooltipStyles();
  const classes = useStyles();
  const [isOpen, toggleOpen] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => toggleOpen(false)}>
      <Tooltip
        open={isOpen}
        classes={tooltipClasses}
        onClose={() => toggleOpen(false)}
        title={
          <>
            {showCloseIcon ? (
              <IconButton
                className={classes.closeIcon}
                onClick={() => toggleOpen(false)}
              >
                <Close />
              </IconButton>
            ) : null}
            <Bill width={'250px'} height={'180px'} />
          </>
        }
        placement={'bottom-start'}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        {children ? (
          <Box
            onClick={e => {
              e.preventDefault();
              toggleOpen(!isOpen);
            }}
          >
            {children}
          </Box>
        ) : (
          <span>
            <TextLink
              tabIndex={tabIndex}
              onClick={e => {
                e.preventDefault();
                toggleOpen(!isOpen);
              }}
              external
              tooltip
            >
              {t('SAMPLE_BILL')}
            </TextLink>
          </span>
        )}
      </Tooltip>
    </ClickAwayListener>
  );
};
